export const convertToIds =
  <T extends { id: string }>(arr: T[]) =>
  () => {
    return new Set(arr.map((item) => item.id));
  };
